import Grid from '@material-ui/core/Grid';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import { convertFromRaw, Editor, EditorState } from 'draft-js';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import React, { useState } from 'react';

import { IHighLight } from '../../../services/interfaces';

import { baseTheme } from '../../../theme';
import GroupPostMenu from './group-post-menu';
import NoSelectWrapper from '../../post-components/post-component/post-editor/no-select-wrapper';
import { getHighlights } from '../../../services/posts';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
      paddingLeft: theme.spacing(0),
      paddingRight: theme.spacing(0),
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(0),
    },
    accordion: {
      width: '100%',

    },
    contentBody: {
      border: 'solid 1px #cdcdcd',
      marginBottom: theme.spacing(1),
      minHeight: '18px',
      maxHeight: '70px',
      overflowY: 'scroll',
    },
    highLight: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      borderBottom: `solid 1px ${theme.palette.text.disabled}`,
    },
    alignRight: {
      textAlign: 'right',
    },
    text: {
      fontWeight: 'bold',
      fontSize: '1.4em',
    },
    expandIconClosed: {
      color: theme.palette.secondary.main,
    },
  }),
);

export default function GroupPostResult(props: any) {
  const { content, date, title, id, tags, linkUrl } = props.post;
  const { groupType } = props;
  const [highlights, setHighlights] = useState<any[]>([]);
  const classes = useStyles(baseTheme);
  const storedState = EditorState.createWithContent(convertFromRaw(JSON.parse(content)));
  const routingUrl: string = linkUrl ? linkUrl.startsWith('http://') || linkUrl.startsWith('https://') ? linkUrl : `http://${linkUrl}` : '';

  const postWithAuthor = {
    ...props.post,
    author: {
      id: props.leader.id,
      displayName: props.leader.displayName,
    },
  };

  const onExpanded = async () => {
    const results: any[] = await getHighlights(id) || [];
    setHighlights(results);
  };

  const renderHighlights = (highlights: IHighLight[]) =>
    highlights ?
      highlights.map((highlight: IHighLight) => (
        <Grid item key={highlight.id} className={classes.highLight}>
          {highlight.content}
        </Grid>
      ))
      : null;
  return (
      <Accordion
        className={classes.accordion}
        TransitionProps={{ unmountOnExit: true }}
        onChange={onExpanded}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon className={groupType === 'Closed' ? classes.expandIconClosed : ''}/>}
          aria-controls="Leader Groups"
          id="leaderId-header"
        >
          <Grid item xs={11}>
            <Typography variant="body2" className={classes.text}>
              {title}
            </Typography>
            <b>
              {date}
            </b>
          </Grid>
          <Grid item xs={1} className={classes.alignRight}>
            <GroupPostMenu post={postWithAuthor} groupType={groupType} />
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Grid item container direction="column">
            <Grid item className={classes.contentBody}>
              <NoSelectWrapper>
                <Editor
                  editorState={storedState}
                  readOnly={true}
                  onChange={() => { }}
                />
              </NoSelectWrapper>
            </Grid>
            {tags && tags.length > 0 &&
            <React.Fragment>
              <b>Tags:</b>
              {tags.map((tag: string) => (
                <Grid item key={`tag-${tag}`}>{tag}</Grid>
                ))}
            </React.Fragment>}
            {routingUrl &&
            <React.Fragment>
              <b>Link:</b>
              <a href={routingUrl} target="_blank" rel="noopener noreferrer">{linkUrl}</a>
            </React.Fragment>}
            <b>Highlights:</b>
            {renderHighlights(highlights)}
          </Grid>
        </AccordionDetails>
      </Accordion>
  );
}
